import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core'
import { Validatable } from './validatable'
import { FieldValidator } from './field-validator'
import { FormValidationService } from './form-validation-service'

export interface ValidatedSelectOptionModel {
    text: string
    value: string | number
}

@Component({
    selector: 'ValidatedDropDown',
    templateUrl: './html-templates/validated-dropdown.component.html'
})
export class ValidatedDropDown extends Validatable<string> implements OnChanges {
    @Input() selectedValue: string
    @Input() label = ''
    @Input() for = ''
    @Input() id = ''
    @Input() options: ValidatedSelectOptionModel[]
    @Input() validators: FieldValidator<string>[] = []
    @Input() disabled = false
    @Input() errorMessages: string[] = []
    @Output() onValueChange: EventEmitter<string> = new EventEmitter<string>()

    constructor(formValidationService: FormValidationService) {
        super(formValidationService)
    }
    ngOnInit() {
        this.id = this.id + this.getId();
    }

    onChange(newValue: any) {
        this.selectedValue = newValue
        this.onValueChange.emit(this.selectedValue)
        this.validate()
    }

    onBlur(): void {
        this.validate()
    }

    getValue(): string {
        return this.selectedValue
    }

    getLabel(): string {
        return this.label
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.disabled && changes.disabled.currentValue) {
            this.clearValidationErrors()
        }
    }
    getDescribedBy(): string | null {
        const ids: string[] = [];
        ids.push(`${this.for}-error`);

        return ids.length ? ids.join('') : null;
    }
    getId() {
        const timestamp = Date.now().toString(36)
        const randomStr = Math.random().toString(36).substring(2, 9)
        return `field-${timestamp}-${randomStr}`//return this.id
    }
}
